import { useLanguage } from "@ihs-widget/utils/hooks/useLanguage";
import { useTranslations } from "../../../../../translation/TranslationContext";
import { useTheme } from "@ihs-widget/stores/ThemeContext";
import { Version } from "@ihs-widget/utils/enums";
import { useVersion } from "@ihs-widget/utils/hooks/useVersion";

interface ICommonSubHeaderProps {
    home_score: string | number;
    away_score: string | number;
    isFirstEvent: boolean;
    eventType: 'HALF_TIME' | 'FULL_TIME' | 'EXTRA_TIME' | 'PENALTIES';
}

const CommonSubHeader = ({ home_score, away_score, isFirstEvent, eventType }: ICommonSubHeaderProps) => {
    const language = useLanguage();
    const t = useTranslations(language);
    const { isV1 } = useVersion();

    const getEventType = (eventType: 'HALF_TIME' | 'FULL_TIME' | 'EXTRA_TIME' | 'PENALTIES') => {
        switch (eventType) {
            case 'HALF_TIME':
                return t[`InHouseStats.OverviewHalfTime`];
            case 'FULL_TIME':
                return t[`InHouseStats.OverviewFullTime`];
            case 'EXTRA_TIME':
                return t[`InHouseStats.OverviewExtraTime`];
            case 'PENALTIES':
                return t[`InHouseStats.OverviewPenalties`];
            default:
                return '';
        }
    }


    return (
        <>
        {isV1 ? (
        <div data-testid={`common-sub-header-${eventType.toLowerCase()}`} 
        className={`flex justify-center items-center text-center text-base0 dark:text-base090 text-[12px] leading-[16px] 
                   bg-graygreen dark:bg-graygreen10 font-robotoRegular font-normal mb-[12px] w-full min-h-[20px]
                   px-[8px] py-[2px] ${isFirstEvent ? 'mt-0' : 'mt-[4px]'}`}>
        <div className="text-center">{getEventType(eventType)}&nbsp;&nbsp;{`${home_score} - ${away_score}`}</div>
        </div>    
        ) : (
            <div data-testid={`common-sub-header-${eventType.toLowerCase()}`} 
            className={`flex justify-center items-center text-center text-brand110 dark:text-highlight-dark text-[12px] leading-[16px] 
                   font-robotoRegular font-normal mb-[12px] w-[calc(100%-42px)] border-b border-brand110 dark:border-highlight-dark 
                   px-[8px] ml-[21px] mr-[41px]  pb-[8px] ${isFirstEvent ? 'mt-[4px]' : 'mt-0'}`}>
            <div className="text-center">{getEventType(eventType)}&nbsp;&nbsp;{`${home_score} - ${away_score}`}</div>
            </div>    
        )}
        </>
    )
}

export default CommonSubHeader;
